const actions = {
    RESET_BASIC_FOODS: "RESET_BASIC_FOODS",
    GET_BASIC_FOODS:"GET_BASIC_FOODS",
    RESET_BRANDED_FOODS: "RESET_BRANDED_FOODS",
    GET_BRANDED_FOODS:"GET_BRANDED_FOODS",
    RESET_RECIPES: "RESET_RECIPES",
    GET_RECIPES:"GET_RECIPES"
}
export default actions;